import { render, staticRenderFns } from "./TaxList.vue?vue&type=template&id=3a148f38&scoped=true&"
import script from "./TaxList.vue?vue&type=script&lang=js&"
export * from "./TaxList.vue?vue&type=script&lang=js&"
import style0 from "./TaxList.vue?vue&type=style&index=0&id=3a148f38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a148f38",
  null
  
)

export default component.exports